import React, { useEffect, useState } from 'react';
import styles from './Styles/LegalDocuments.module.css';
import {
  getDocument,
  setDocument,
  updateDocument,
} from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';

const LEGAL_TYPES = ['TERMS_OF_USE', 'PRIVACY_POLICY', 'WAIVER'];

export default function LegalDocuments({ user }) {
  const [selectedType, setSelectedType] = useState(LEGAL_TYPES[0]);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [documentExists, setDocumentExists] = useState(false);

  const fetchDocument = async (type) => {
    setLoading(true);
    setStatus('');
    try {
      const data = await getDocument(type);
      setContent(data.content || '');
      setDocumentExists(true);
    } catch (err) {
      setContent('');
      setStatus('No document found. You can create one.');
      setDocumentExists(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument(selectedType);
  }, [selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Saving...');
    try {
      const payload = { type: selectedType, content };
      documentExists ? await updateDocument(selectedType, { content }) : await setDocument(payload);
      setStatus('Saved successfully!');
      setDocumentExists(true);
    } catch (err) {
      setStatus('Error saving document.');
    }
  };

  return (
    <div className={styles.container}>
      <h2>Legal Documents</h2>
      <div className={styles.controls}>
        <label>Select Document Type:</label>
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          {LEGAL_TYPES.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit} className={styles.form}>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter document content..."
            className={styles.textarea}
            rows={12}
          />
          <button type="submit" className={styles.saveBtn}>Save</button>
          {status && <div className={styles.status}>{status}</div>}
        </form>
      )}
    </div>
  );
}
